import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon, MailIcon } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
export function ForgotPassword() {
  const navigate = useNavigate();
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    navigate('/auth/reset');
  };
  return <div className="w-full h-full bg-black flex flex-col" data-id="element-205">
      <div className="px-4 py-6 flex items-center" data-id="element-206">
        <button onClick={() => navigate(-1)} className="p-2 -ml-2 text-white hover:bg-surface rounded-full transition-colors" data-id="element-207">
          <ArrowLeftIcon size={24} data-id="element-208" />
        </button>
      </div>

      <div className="flex-1 px-6 pb-6" data-id="element-209">
        <div className="mb-8" data-id="element-210">
          <h1 className="text-3xl font-poppins font-bold text-white mb-2" data-id="element-211">
            Forgot password?
          </h1>
          <p className="text-softGray" data-id="element-212">
            Enter your email and we'll send you a reset link.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="flex flex-col gap-5" data-id="element-213">
          <Input label="Email or Phone" placeholder="Enter your email" icon={<MailIcon size={20} data-id="element-215" />} type="email" data-id="element-214" />
          <Button type="submit" className="mt-4" data-id="element-216">
            Send Reset Link
          </Button>
        </form>
      </div>
    </div>;
}